<template>

    <div id="dashboard">
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Tutorial do CRM" />
                <div class="row card-panel mb-2 mt-1">
                    <div class="row hide-on-med-and-down">
                        <div class="col s12 m12 l12">
                        <button
                            class="btn btn-default waves-effect waves-light left mb-1"
                            @click="restartTour"
                        >
                            <i class="material-icons left">play_circle_outline</i>
                            Começar Tutorial
                        </button>
                        </div>
                    </div>
                    <p class="row hide-on-med-and-down">Clicando no botão acima você terá acesso a informações sobre:</p>
                    <!-- DONO -->
                    <div class="ajuda-dono"  v-if="checaCargoUsuario([cargoDono], [cargoDono])">
                        <div class="col s12 m12 l6">
                            <ul>
                                <li><p class="uppercase strong">Dashboard</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a Dashboard</li>
                                <li ><i class="material-icons green-text">check</i> Criação de eventos na agenda</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Gerenciamento de leads</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a listagem dos leads</li>
                                <li><i class="material-icons green-text">check</i> Como excluir um/vários leads</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul v-if="!showMultiEmpresa">
                                <li><p class="uppercase strong">Histórico do cliente</p></li>
                                <li><i class="material-icons green-text">check</i> Como alterar os dados</li>
                                <li><i class="material-icons green-text">check</i> Como colocar o Lead em espera ou negativá-lo a qualquer momento</li>
                                <li><i class="material-icons green-text">check</i> Troca de consultor</li>
                                <li><i class="material-icons green-text">check</i> Visualização do status do produto</li>
                                <li><i class="material-icons green-text">check</i> Área de acompanhamento do progresso do lead na esteira</li>
                                <li><i class="material-icons green-text">check</i> Tarefas que foram executadas, que estão sendo e ainda vão ser</li>
                                <li><i class="material-icons green-text">check</i> Como pular etapas</li>
                                <li><i class="material-icons green-text">check</i> Inclusão de anexo</li>
                            </ul>
                            <ul v-if="!showMultiEmpresa">
                                <li><p class="uppercase strong">Leads Removidos</p></li>
                                <li><i class="material-icons green-text">check</i> Como restaurar o lead</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul v-if="!showMultiEmpresa">
                                <li><p class="uppercase strong">Clientes / Cadastro</p></li>
                                <li><i class="material-icons green-text">check</i> Como selecionar os produtos</li>
                                <li><i class="material-icons green-text">check</i> Encontrar os detalhes de cada produto</li>
                                <li><i class="material-icons green-text">check</i> Concluir o cadastro</li>
                            </ul>
                        </div>
                        <div class="col s12 m12 l6">
                            <ul v-if="!showMultiEmpresa">
                                <li><p class="uppercase strong">Clientes / Indicações</p></li>
                                <li><i class="material-icons green-text">check</i> Como indicar um consultor para ser responsável por um lead</li>
                                <li><i class="material-icons green-text">check</i> Excluir um lead indicado</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Clientes / Importação</p></li>
                                <li><i class="material-icons green-text">check</i> Como baixar o modelo do arquivo</li>
                                <li><i class="material-icons green-text">check</i> Onde se encontra as instruções para preenchimento do modelo</li>
                                <li><i class="material-icons green-text">check</i> Como importar para o CRM a planilha preenchida</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">{{lang.empresa.plural}}</p></li>
                                <li><i class="material-icons green-text">check</i> Como editar informações de uma {{lang.empresa.singular}} já cadastrada</li>
                                <li><i class="material-icons green-text">check</i> Como cadastrar uma nova {{lang.empresa.singular}}</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Funcionário</p></li>
                                <li><i class="material-icons green-text">check</i> Como editar informações de um funcionário já cadastrado</li>
                                <li><i class="material-icons green-text">check</i> Como cadastrar um novo funcionário</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Funcionário / Situação atual</p></li>
                                <li><i class="material-icons green-text">check</i> Como ler os dados</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Produtos</p></li>
                                <li><i class="material-icons green-text">check</i> Como editar informações de um produto já cadastrado</li>
                                <li><i class="material-icons green-text">check</i> Como cadastrar um novo produto</li>
                            </ul>
                        </div>
                    </div>
                    <!-- GERENTE -->
                    <div class="ajuda-gerente" v-if="checaCargoUsuario([cargoGerente], [cargoGerente])">
                        <div class="col s12 m12 l6">
                            <ul>
                                <li><p class="uppercase strong">Dashboard</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a Dashboard</li>
                                <li><i class="material-icons green-text">check</i> Criação de eventos na agenda</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Gerenciamento de leads</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a listagem dos leads</li>
                                <li><i class="material-icons green-text">check</i> Como excluir um/vários leads</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Histórico do cliente</p></li>
                                <li><i class="material-icons green-text">check</i> Como alterar os dados</li>
                                <li><i class="material-icons green-text">check</i> Como colocar o Lead em espera ou negativá-lo a qualquer momento</li>
                                <li><i class="material-icons green-text">check</i> Troca de consultor</li>
                                <li><i class="material-icons green-text">check</i> Visualização do status do produto</li>
                                <li><i class="material-icons green-text">check</i> Área de acompanhamento do progresso do lead na esteira</li>
                                <li><i class="material-icons green-text">check</i> Tarefas que foram executadas, que estão sendo e ainda vão ser</li>
                                <li><i class="material-icons green-text">check</i> Como pular etapas</li>
                                <li><i class="material-icons green-text">check</i> Inclusão de anexo</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Leads Removidos</p></li>
                                <li><i class="material-icons green-text">check</i> Como restaurar o lead</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                        </div>
                        <div class="col s12 m12 l6">
                            <ul>
                                <li><p class="uppercase strong">Clientes / Cadastro</p></li>
                                <li><i class="material-icons green-text">check</i> Como selecionar os produtos</li>
                                <li><i class="material-icons green-text">check</i> Encontrar os detalhes de cada produto</li>
                                <li><i class="material-icons green-text">check</i> Concluir o cadastro</li>
                            </ul>

                            <ul>
                                <li><p class="uppercase strong">Clientes / Indicações</p></li>
                                <li><i class="material-icons green-text">check</i> Como indicar um consultor para ser responsável por um lead</li>
                                <li><i class="material-icons green-text">check</i> Excluir um lead indicado</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Clientes / Importação</p></li>
                                <li><i class="material-icons green-text">check</i> Como baixar o modelo do arquivo</li>
                                <li><i class="material-icons green-text">check</i> Onde se encontra as instruções para preenchimento do modelo</li>
                                <li><i class="material-icons green-text">check</i> Como importar para o CRM a planilha preenchida</li>
                            </ul>
                            <ul v-if="!showMultiEmpresa">
                                <li><p class="uppercase strong">Empresas</p></li>
                                <li><i class="material-icons green-text">check</i> Como editar informações de uma empresa já cadastrada</li>
                                <li><i class="material-icons green-text">check</i> Como cadastrar uma nova empresa</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Funcionário / Situação atual</p></li>
                                <li><i class="material-icons green-text">check</i> Como ler os dados</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                        </div>
                    </div>
                    <!-- CORRETOR -->
                    <div class="ajuda-corretor" v-if="checaCargoUsuario([cargoCorretor], [cargoCorretor])">
                        <div class="col s12">
                            <ul>
                                <li><p class="uppercase strong">Dashboard</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a Dashboard</li>
                                <li><i class="material-icons green-text">check</i> Kanban com o estagio que os leads se encontram</li>
                                <li><i class="material-icons green-text">check</i> Criação de eventos na agenda</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Gerenciamento de leads</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a listagem dos leads</li>
                                <li><i class="material-icons green-text">check</i> Como excluir um/vários leads</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul v-if="showMultiEmpresa">
                                <li><p class="uppercase strong">Histórico do cliente</p></li>
                                <li><i class="material-icons green-text">check</i> Como alterar os dados</li>
                                <li><i class="material-icons green-text">check</i> Como colocar o Lead em espera ou negativá-lo a qualquer momento</li>
                                <li><i class="material-icons green-text">check</i> Troca de consultor</li>
                                <li><i class="material-icons green-text">check</i> Visualização do status do produto</li>
                                <li><i class="material-icons green-text">check</i> Área de acompanhamento do progresso do lead na esteira</li>
                                <li><i class="material-icons green-text">check</i> Tarefas que foram executadas, que estão sendo e ainda vão ser</li>
                                <li><i class="material-icons green-text">check</i> Como pular etapas</li>
                                <li><i class="material-icons green-text">check</i> Inclusão de anexo</li>
                            </ul>
                            <ul v-if="showMultiEmpresa">
                                <li><p class="uppercase strong">Clientes / Cadastro</p></li>
                                <li><i class="material-icons green-text">check</i> Como selecionar os produtos</li>
                                <li><i class="material-icons green-text">check</i> Encontrar os detalhes de cada produto</li>
                                <li><i class="material-icons green-text">check</i> Concluir o cadastro</li>
                            </ul>
                        </div>
                    </div>
                    <!-- ESPECIALISTA -->
                    <div class="ajuda-especialista" v-if="checaCargoUsuario([cargoEspecialista], [cargoEspecialista])">
                        <div class="col s12 m12 l6">
                            <ul>
                                <li><p class="uppercase strong">Dashboard</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a Dashboard</li>
                                <li><i class="material-icons green-text">check</i> Criação de eventos na agenda</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Gerenciamento de leads</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a listagem dos leads</li>
                                <li><i class="material-icons green-text">check</i> Como excluir um/vários leads</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Histórico do cliente</p></li>
                                <li><i class="material-icons green-text">check</i> Como alterar os dados</li>
                                <li><i class="material-icons green-text">check</i> Como colocar o Lead em espera ou negativá-lo a qualquer momento</li>
                                <li><i class="material-icons green-text">check</i> Troca de consultor</li>
                                <li><i class="material-icons green-text">check</i> Visualização do status do produto</li>
                                <li><i class="material-icons green-text">check</i> Área de acompanhamento do progresso do lead na esteira</li>
                                <li><i class="material-icons green-text">check</i> Tarefas que foram executadas, que estão sendo e ainda vão ser</li>
                                <li><i class="material-icons green-text">check</i> Como pular etapas</li>
                                <li><i class="material-icons green-text">check</i> Inclusão de anexo</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Leads Removidos</p></li>
                                <li><i class="material-icons green-text">check</i> Como restaurar o lead</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                        </div>
                        <div class="col s12 m12 l6">
                            <ul>
                                <li><p class="uppercase strong">Clientes / Cadastro</p></li>
                                <li><i class="material-icons green-text">check</i> Como selecionar os produtos</li>
                                <li><i class="material-icons green-text">check</i> Encontrar os detalhes de cada produto</li>
                                <li><i class="material-icons green-text">check</i> Concluir o cadastro</li>
                            </ul>

                            <ul>
                                <li><p class="uppercase strong">Clientes / Indicações</p></li>
                                <li><i class="material-icons green-text">check</i> Como indicar um consultor para ser responsável por um lead</li>
                                <li><i class="material-icons green-text">check</i> Excluir um lead indicado</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Clientes / Importação</p></li>
                                <li><i class="material-icons green-text">check</i> Como baixar o modelo do arquivo</li>
                                <li><i class="material-icons green-text">check</i> Onde se encontra as instruções para preenchimento do modelo</li>
                                <li><i class="material-icons green-text">check</i> Como importar para o CRM a planilha preenchida</li>
                            </ul>
                            <ul v-if="!showMultiEmpresa">
                                <li><p class="uppercase strong">Empresas</p></li>
                                <li><i class="material-icons green-text">check</i> Como editar informações de uma empresa já cadastrada</li>
                                <li><i class="material-icons green-text">check</i> Como cadastrar uma nova empresa</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Funcionário / Situação atual</p></li>
                                <li><i class="material-icons green-text">check</i> Como ler os dados</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                        </div>
                    </div>
                    <!-- LIDER -->
                    <div class="ajuda-lider" v-if="checaCargoUsuario([cargoLider], [cargoLider])">
                        <div class="col s12">
                            <ul>
                                <li><p class="uppercase strong">Dashboard</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a Dashboard</li>
                                <li><i class="material-icons green-text">check</i> Kanban com o estagio que os leads se encontram</li>
                                <li><i class="material-icons green-text">check</i> Criação de eventos na agenda</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Gerenciamento de leads</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a listagem dos leads</li>
                                <li><i class="material-icons green-text">check</i> Como excluir um/vários leads</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul v-if="showMultiEmpresa">
                                <li><p class="uppercase strong">Histórico do cliente</p></li>
                                <li><i class="material-icons green-text">check</i> Como alterar os dados</li>
                                <li><i class="material-icons green-text">check</i> Como colocar o Lead em espera ou negativá-lo a qualquer momento</li>
                                <li><i class="material-icons green-text">check</i> Troca de consultor</li>
                                <li><i class="material-icons green-text">check</i> Visualização do status do produto</li>
                                <li><i class="material-icons green-text">check</i> Área de acompanhamento do progresso do lead na esteira</li>
                                <li><i class="material-icons green-text">check</i> Tarefas que foram executadas, que estão sendo e ainda vão ser</li>
                                <li><i class="material-icons green-text">check</i> Como pular etapas</li>
                                <li><i class="material-icons green-text">check</i> Inclusão de anexo</li>
                            </ul>
                            <ul v-if="showMultiEmpresa">
                                <li><p class="uppercase strong">Clientes / Cadastro</p></li>
                                <li><i class="material-icons green-text">check</i> Como selecionar os produtos</li>
                                <li><i class="material-icons green-text">check</i> Encontrar os detalhes de cada produto</li>
                                <li><i class="material-icons green-text">check</i> Concluir o cadastro</li>
                            </ul>
                        </div>
                    </div>
                    <!-- PARCEIRO -->
                     <div class="ajuda-parceiro" v-if="!showMultiEmpresa && checaCargoUsuario([cargoParceiro],[])">
                        <div class="col s12 m12 l6">
                            <ul>
                                <li><p class="uppercase strong">Dashboard</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a Dashboard</li>
                                <li><i class="material-icons green-text">check</i> Criação de eventos na agenda</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Gerenciamento de leads</p></li>
                                <li><i class="material-icons green-text">check</i> O que compõe a listagem dos leads</li>
                                <li><i class="material-icons green-text">check</i> Como excluir um/vários leads</li>
                                <li><i class="material-icons green-text">check</i> Utilização dos filtros</li>
                                <li><i class="material-icons green-text">check</i> Como exportar a listagem</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Histórico do cliente</p></li>
                                <li><i class="material-icons green-text">check</i> Como alterar os dados</li>
                                <li><i class="material-icons green-text">check</i> Como colocar o Lead em espera ou negativá-lo a qualquer momento</li>
                                <li><i class="material-icons green-text">check</i> Troca de consultor</li>
                                <li><i class="material-icons green-text">check</i> Visualização do status do produto</li>
                                <li><i class="material-icons green-text">check</i> Área de acompanhamento do progresso do lead na esteira</li>
                                <li><i class="material-icons green-text">check</i> Tarefas que foram executadas, que estão sendo e ainda vão ser</li>
                                <li><i class="material-icons green-text">check</i> Como pular etapas</li>
                                <li><i class="material-icons green-text">check</i> Inclusão de anexo</li>
                            </ul>
                            <ul>
                                <li><p class="uppercase strong">Clientes / Cadastro</p></li>
                                <li><i class="material-icons green-text">check</i> Como selecionar os produtos</li>
                                <li><i class="material-icons green-text">check</i> Encontrar os detalhes de cada produto</li>
                                <li><i class="material-icons green-text">check</i> Concluir o cadastro</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
            <!--end container-->
        </section>

  </div>
</template>
<script>
    import TituloPagina from '@/components/common/TituloPagina';
    import TourStore from '@/store/tour';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import getPalavra from '@/helpers/language';
    import { checaCargo } from '@/helpers/perfil';
    import
    {
        isMultiEmpresa
    }
    from '@/environment';

    export default {
        components: {
            TituloPagina

        },
        data: () => ({
            lang:{
                empresa:{
                    plural: getPalavra('empresa', false, true),
                    singular: getPalavra('empresa')
                }
            },
            usuarioLogadoCargo: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoEspecialista: null,
            cargoLider: null,
            cargoParceiro: null,
            showMultiEmpresa: isMultiEmpresa,
        }),
        created() {
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;
            this.cargoLider = LIDER;
            this.cargoParceiro = PARCEIRO;
        },
        methods: {
           restartTour(){
               TourStore.resetTours();
               this.$router.push('/');
           },
            checaCargoUsuario(cargoMono, cargoMulti){
              return checaCargo(cargoMono, cargoMulti)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ajuda/Tutorial.vue